<div class="unavailable-card" data-progress-card>
  <div class="unavailable-card__logo">
    <img [src]="item?.image" [alt]="item?.name" />
  </div>
  <div class="unavailable-card__status">
    <svg class="unavailable-card__icon" viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M5 3.5h10.5v8M5 3.5v15.5a1.5 1.5 0 0 0 1.5 1.5h7M8 8h4.5M8 11.5h4.5M8 15h3"
        fill="none"
        stroke="currentColor"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 15.5l4.5 4.5M20.5 15.5L16 20"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
      />
    </svg>
    <div class="unavailable-card__text">
      <div class="unavailable-card__title">
        {{ "comparison.progress.unavailableTitle" | translate }}
      </div>
      <div class="unavailable-card__desc">
        {{ "comparison.progress.unavailableDesc" | translate }}
      </div>
    </div>
  </div>
</div>
